import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const BgBottomSquareIcon = ({
  width = "213",
  height = "32",
  color = "#CEDFEE",
  style,
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} style={style}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 213 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M213 0L35.2791 0.00410489C26.5583 0.052538 18.4164 4.36201 13.4936 11.5352L0 31.5295H213V0Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
